import { Environment } from '@react-three/drei';
import { Suspense } from 'react';
import { useShallow } from 'zustand/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const SceneEnvironment = () => {
    const { shadowsEnabled, reflectionsEnabled, showIfc } = usePlacementStore(
        useShallow((state) => state.graphicsSettings)
    );

    const environmentIntensity = reflectionsEnabled ? 1.1 : showIfc || shadowsEnabled ? 0.75 : 0;

    return (
        <Suspense>
            <Environment
                background={false}
                backgroundBlurriness={0}
                backgroundIntensity={1}
                environmentIntensity={environmentIntensity}
                environmentRotation={[Math.PI / 2, -1, 0]}
                preset="warehouse"
            />
        </Suspense>
    );
};
